/**
 * 铺位信息管理
 */
import React from 'react';

import { Input, Row, Col, Icon, Tooltip, Button, Select } from 'antd';

import PageLayout from '../../ui/PageLayout';

import BerthManageEdit from './BerthManageEdit';

import http from '../../../axios/http';

import moment from 'moment';

import { fixedNumber } from '../../../util/util.js';

import { global_data } from '../../ui/auth'

class BetrthManageIndex extends React.Component {

    columns = [{
        title: '楼层',
        dataIndex: 'floorName',
        width: '10%',
    }, {
        title: '铺位',
        dataIndex: 'berthCode',
        width: '10%',
    }, 
    // {
    //     title: '计租面积/㎡',
    //     dataIndex: 'area',
    //     width: '10%',
    // }, 
    {
        title: '计租面积/㎡',
        dataIndex: 'buildingArea',
        width: '10%',
    }, 
    {
        title: '物业费 元/(月*㎡)',
        dataIndex: 'propertyCost',
        width: '10%',
    }, {
        title: '总租金(元)',
        dataIndex: 'totalRent',
        width: '10%',
        render: (text, record, index) => {
            if(text != null && text !== ""){
                text = fixedNumber(text);
            }
            return (<div>
                <Tooltip title={text}>{text}</Tooltip>
            </div>)
        }
    }, {
        title: '状态',
        dataIndex: 'status',
        width: '10%',
        format: { 0: '未租', 1: '已租' }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("BERTH_MANAGE_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        teamVisible: false,
        floorList: [],
        allFloorList: [],
        buildingList: [],
    };

    componentDidMount = () => {
        http.get({
            url: "/berth/findBuilding",
            success: (res) => {
                let buildingList = res == null ? [] : res;
                let buildingId = buildingList[0] == null ? null : buildingList[0]["id"] + "";
                let queryData = { buildingId: buildingId };
                this.setState({ buildingList: buildingList, queryData: queryData });
                this.state.loadData(queryData);
                http.get({
                    url: "/berth/findFloor",
                    success: (floor) => {
                        floor = floor == null ? [] : floor;
                        let floorList = [];
                        if (buildingId != null) {
                            floor.forEach(item => {
                                // eslint-disable-next-line eqeqeq
                                if (item.buildingId == buildingId) {
                                    floorList.push(item);
                                }
                            });
                        }
                        this.setState({ floorList: floorList, allFloorList: floor });
                    }
                });
            }
        });
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    add = () => {
        let year = moment().year();
        let rentList = [];
        let area = 0;
        for (let i = 0; i < 15; i++) {
            rentList.push({ year: year + i, rent: 0 });
        }
        this.setState({
            editData: {
                yearNum: rentList.length,
                area: 0,
                totalRent: 0,
                averageRent: 0
            }
        });
        this.state.initEdit(rentList, area);
        this.showModal();
    }

    update = (info, e) => {
        let rentList = info["rentList"];
        if (rentList == null || rentList.length === 0) {
            let year = moment().year();
            for (let i = 0; i < 15; i++) {
                rentList.push({ year: year + i, rent: 0 });
            }
        } else {
            info["averageRent"] = fixedNumber(info["totalRent"] / rentList.length, 0);
        }
        info["yearNum"] = rentList.length;
        let area = info.buildingArea;
        if (info.totalRent) {
            info.totalRent = fixedNumber(info.totalRent, 0);
        }
        this.setState({ editData: info });
        this.state.initEdit(info["rentList"], area);
        this.showModal();
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.berthCode = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (field, value, e) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        if (field === "buildingId") {
            let floor = this.state.allFloorList;
            let floorList = [];
            floor.forEach(item => {
                // eslint-disable-next-line eqeqeq
                if (item.buildingId == value) {
                    floorList.push(item);
                }
            });
            this.setState({ floorList: floorList });
            queryData["floorId"] = null;
        }
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Select placeholder="市场" onChange={this.selectChange.bind(this, "buildingId")} value={this.state.queryData.buildingId} allowClear={true} style={{ width: 200 }}>
                                    {this.state.buildingList.map(d =>
                                        <Select.Option key={d["id"]}>{d["buildingName"]}</Select.Option>
                                    )}
                                </Select>
                                <Select placeholder="楼层" onChange={this.selectChange.bind(this, "floorId")} value={this.state.queryData.floorId} allowClear={true} style={{ width: 200, margin: '0 10px' }}>
                                    {this.state.floorList.map(d =>
                                        <Select.Option key={d["id"]}>{d["floorName"]}</Select.Option>
                                    )}
                                </Select>
                                <Input.Search
                                    placeholder="铺位"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 200 }}
                                />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("BERTH_MANAGE_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/berth/findBerthPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <BerthManageEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    floorList={this.state.floorList}

                    initEdit={(func) => { this.setState({ initEdit: func }) }}
                />
            </div>
        )
    }
}

export default BetrthManageIndex;